module.exports = __webpack_public_path__ + "img/3.26758151.png";